// @flow
import React, { useContext, type Node } from 'react'
import {
    Box,
} from 'sarsaparilla'
import { LayoutControlContext } from './DetailedAvailabilityPageLayout'

type PropTypes = {
    children: Node,
}
const DetailedAvailabilityGridAndActions = ({
    children,
}: PropTypes) => {
    const {
        isFullView,
        isInformationRequired,
        isMobileApp,
        isShowAvailabilityFilters,
    } = useContext(LayoutControlContext);

    if(isInformationRequired || (isShowAvailabilityFilters && isMobileApp)) {
        return null;
    }

    return (
        <Box>
            {React.Children.map(children, child => {
                if (React.isValidElement(child)) {
                    // All this because AvailabilityGrid needs this prop
                    return React.cloneElement(child, { isFullView });
                }
                return child;
            })}
        </Box>
    )
}

export default DetailedAvailabilityGridAndActions;